import React from 'react';
import MarginBox from '../../shared/components/other/MarginBox';
import NavBar from '../../shared/components/navbar/NavBar';
import Footer from '../../shared/components/other/Footer';
import './GameInfo.scss'
import Button from '../../shared/components/UI/Button';
import GameTags from '../../shared/components/other/GameTags/GameTags';
import Map from '../../shared/components/Map/Map';
import { translateTags } from '../../shared/services/CalendarServices';
import { useParams } from 'react-router';
import useEventsValues from '../../shared/hooks/useEventInfo';
import Slider from './components/Swiper';
import { FormatDate } from '../../shared/shared';
import { dialogNotify, displayNotImplemented, displayStandartDialog } from '../../shared/services/Notifications/NotificationServices';
import Loading from '../../shared/components/Loading/loading';
import useEventRegistration from '../../shared/hooks/useEventRegistration';
import Image from '../../shared/components/other/Image';
//Правки
//Карту сделать адаптивной
//
// Писать координаты полигона у карты
// СДлеать ссылку открыть в яндекс картах у компонента Map (желетально)
// СДелать свайпер для страницы с игрой 
// Календарь добавить адаптивность плашек (чтоб они смещались при сдвиге окна)


//На будущее (не текущий спринт)
//Октрывать картинку на полный экран на странице полигона (если она по цыентру - иначе прееместить)
//ОБеспечить повторное использование свайпера из страницы полигона где - нгибудь еще 
//Потом будет страница для простмотра фотографий

//НА проверку
//проверить скругления у картинок в полигоне

const GameInfo = () => {

    const { guID } = useParams();

    const { data, isLoading, error } = useEventsValues(guID);

    const { regMutate, unregMutate, isPending } = useEventRegistration(data?.id)

    const is_registered = data?.user_is_registered

    const registrationButton_content =
        isPending ? 'Обработка...' : (
            is_registered ? 'Отменить регистрацию' : 'Зарегистрироваться')

    const regAction = () => {
        dialogNotify({
            status: 'info',
            title: 'Киберштаб',
            description: 'Вы действительно хотите зарегистрироваться на мероприятие?',
            acceptHandler: regMutate,
            acceptText: 'Да',
            rejectText: 'Нет'
        })
    }

    const unregAction = () => {
        dialogNotify({
            status: 'info',
            title: 'Киберштаб',
            description: 'Вы действительно хотите отказаться от регистрации?',
            acceptHandler: unregMutate,
            acceptText: 'Да',
            rejectText: 'Нет'
        })
    }

    const registrationButton_action = is_registered ? unregAction : regAction

    const registrationButton = <Button onClick={registrationButton_action} className="gameInfo_button gameInfo_regButton">{registrationButton_content}</Button>

    return (
        <Loading isLoading={isLoading} error={error} data={data}>
            {(dataGameInfo) => {


                const conditions = translateTags(dataGameInfo.ground.conditions);

                return (
                    <MarginBox>
                        <NavBar />
                        <main className='gameInfo_main'>
                            <div className="gameInfo_tab gameInfo_info">
                                <div>
                                    <h1 className="gameInfo_h1">{dataGameInfo.name}</h1>
                                    <p className="gameInfo_date">{FormatDate(dataGameInfo.start_datetime)}</p>
                                    <a className="gameInfo_place" href={`/locationMeet/${dataGameInfo.ground.slug}`}>{dataGameInfo.ground.title}</a>
                                </div>
                                <div>

                                    <GameTags openState={dataGameInfo.state} peopleCount={dataGameInfo.count_participants_total || '0'} additionalTags={dataGameInfo.tags.map((tag: any) => tag.name)}></GameTags>
                                </div>

                                <div className="gameInfo_orgInfo">
                                    <img src={dataGameInfo.hosts[0].logo_link || '../EmptyProfileSection/ava_empty.png'} alt="" className="gameInfo_orgInfo_icon" />
                                    <div className="gameInfo_orgInfo_text">
                                        <p className="gameInfo_orgInfo_orgName">{dataGameInfo.hosts[0].name}</p>
                                        <p className="gameInfo_orgInfo_title">Организатор</p>
                                    </div>
                                </div>
                                <div>
                                    {registrationButton}
                                    <Button onClick={displayNotImplemented} className="gameInfo_button gameInfo_contactButton" darkStyle>Связаться с организатором</Button>
                                </div>
                            </div>
                            <div className="gameInfo_tab gameInfo_additional_info">
                                {/* Для тестирования изображений под разные размеры блока */}
                                
                                {/* <Image s3={'1d85793b.jpg'} className='image-container_3' namePage='events' slug='29537-straikbol-igra-03-25' /> */}

                                <Slider urlImages={dataGameInfo.images.map((image: any) => image.image_link)} />

                                <h2 className="gameInfo_h2">О событии</h2>
                                <p className="gameInfo_annotation">
                                    {dataGameInfo.description}
                                </p>
                                <h2 className="gameInfo_h2">Условия</h2>
                                <ul className="gameInfo_conditions">
                                    {conditions}
                                </ul>
                                <h2 className="gameInfo_h2">Взносы</h2>
                                <p className="gameInfo_priceList">
                                    {dataGameInfo.pricing}
                                </p>
                                <h2 className="gameInfo_h2">Место проведения</h2>
                                <a className="gameInfo_place gameInfo_place_nearMap" href={`/locationMeet/${dataGameInfo.ground.slug}`}>{dataGameInfo.ground.title}</a>
                                <Map className='gameInfo_map' coordinates={dataGameInfo.ground.coordinates}></Map>
                            </div>
                        </main>
                        <Footer></Footer>
                    </MarginBox>
                );
            }}
        </Loading>
    );
}

export default GameInfo;
